<template>
  <v-app id="app_measurements">
    <v-overlay
      v-model="centerLoading"
      :scrim="false"
      class="custom_centered_overlay"
    >
      <v-progress-circular
        color="#2A8200"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

    <v-container fluid>
      <v-row>
        <v-col class="mt-0" cols="7">
          <p class="custom_page_main_title">TIME MANAGEMENT</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">
            Used to configure the business hours.
          </p>
        </v-col>
        <v-col class="px-4 mt-7" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider
              :thickness="3"
              class="divider-vertical"
              vertical
            ></v-divider>
            <v-btn
              class="gray-text"
              size="x-large"
              variant="text"
              @click="backPageRoute"
            >
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="pa-5 mt-8">
        <v-row>
          <v-col cols="12" md="4">
            <v-select
              v-model="selectedDay"
              :items="days"
              label="Day*"
              variant="outlined"
              density="comfortable"
              class="custom_input_field_color"
              item-title="name"
              item-value="value"
              clearable
              :rules="[(v) => !!v || 'Day is required']"
              :disabled="!permissions.write"
            ></v-select>
          </v-col>

          <v-col cols="12" md="4">
            <v-menu
              v-model="dayInMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="dayInTime"
                  label="Day In"
                  variant="outlined"
                  readonly
                  v-bind="props"
                  class="custom_input_field_color"
                  :rules="[(v) => !!v || 'Day In is required']"
                  :disabled="!permissions.write"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="dayInTime"
                format="24hr"
                @click:minute="dayInMenu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="4">
            <v-menu
              v-model="dayInBufferMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="dayInBufferTime"
                  label="Day In Buffer"
                  variant="outlined"
                  readonly
                  v-bind="props"
                  class="custom_input_field_color"
                  :rules="[(v) => !!v || 'Day In Buffer is required']"
                  :disabled="!permissions.write"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="dayInBufferTime"
                format="24hr"
                @click:minute="dayInBufferMenu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <v-menu
              v-model="morningHDMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="morningHDTime"
                  label="Morning HD Leave"
                  variant="outlined"
                  readonly
                  v-bind="props"
                  class="custom_input_field_color"
                  :rules="[(v) => !!v || 'Morning HD Leave is required']"
                  :disabled="!permissions.write"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="morningHDTime"
                format="24hr"
                @click:minute="morningHDMenu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="4">
            <v-menu
              v-model="afternoonHDMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="afternoonHDTime"
                  label="Afternoon HD Leave"
                  variant="outlined"
                  readonly
                  v-bind="props"
                  class="custom_input_field_color"
                  :rules="[(v) => !!v || 'Afternoon HD Leave is required']"
                  :disabled="!permissions.write"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="afternoonHDTime"
                format="24hr"
                @click:minute="afternoonHDMenu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="4">
            <v-menu
              v-model="fullDayLeaveMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="fullDayLeaveTime"
                  label="Full Day Leave"
                  variant="outlined"
                  readonly
                  v-bind="props"
                  class="custom_input_field_color"
                  :disabled="!permissions.write"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="fullDayLeaveTime"
                format="24hr"
                @click:minute="fullDayLeaveMenu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <v-menu
              v-model="dayOutMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="dayOutTime"
                  label="Day Out"
                  variant="outlined"
                  readonly
                  v-bind="props"
                  class="custom_input_field_color"
                  :disabled="!permissions.write"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="dayOutTime"
                format="24hr"
                @click:minute="dayOutMenu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-divider></v-divider>

          <v-row justify="end" class="pa-4">
            <v-btn
              size="x-large"
              class="custom_btn_primary pl-5 pr-5"
              @click="verifyDialogOpen"
              :disabled="!permissions.write"
              >Create</v-btn
            >
            <!-- <v-btn size="x-large" class="custom_btn_primary pl-5 pr-5" @click="CreateTime()">Create</v-btn> -->
            <v-btn
              size="x-large"
              class="custom_btn_secondary ml-3"
              @click="cancel()"
              :disabled="!permissions.write"
              >Cancel</v-btn
            >
          </v-row>

          <v-divider></v-divider>
        </v-row>

        <v-row>
          <v-col class="mt-0" cols="7">
            <p class="custom_page_main_title">LIST OF TIME DATA</p>
            <p class="custom_page_main_sub_title" style="opacity: 0.6">
              List of the all configure business hours.
            </p>
          </v-col>

          <v-dialog
            v-model="createDialog"
            max-height="700"
            max-width="700"
            persistent
            id="app_product_list"
          >
            <v-card rounded="md">
              <div class="pa-4">
                <v-card color="#F0F0F0" flat>
                  <template v-slot:prepend>
                    <v-card-title class="text-subtitle-1 font-weight-bold"
                      >CREATE TIME MANAGEMENT DATA</v-card-title
                    >
                  </template>
                  <v-spacer></v-spacer>
                  <template v-slot:append>
                    <v-btn
                      @click="createDialog = false"
                      icon="mdi-close"
                      size="x-small"
                    ></v-btn>
                  </template>
                </v-card>

                <v-card color="white" flat class="mt-3">
                  <v-card-item>
                    <v-card-title
                      style="color: #bb0000"
                      class="text-body-1 font-weight-medium"
                    >
                      <v-icon color="warning" size="small">mdi-alert</v-icon>
                      &nbsp;&nbsp;Do you want to confirm this as a new time schedule for the {{ this.selectedDay }} ?
                    </v-card-title>

                    <p
                      style="opacity: 0.7"
                      class="text-body-2 mt-4 text-justify"
                    >
                    Once published, this timeline will be applied to all future {{ this.selectedDay }}.
                      <span style="color: blue">
                        Please double-check the selected times before confirming, as this change will take effect immediately.
                      </span>
                    </p>

                    <v-divider class="mt-4"></v-divider>

                    <div class="float-end mt-4">
                      <v-btn
                      size="x-large"
                      class="custom_btn_primary pl-5 pr-5"
                        @click="CreateTime()"
                        :loading="deleteLoading"
                        :disabled="!permissions.write"
                      >
                        CREATE
                      </v-btn>
                      <!-- <v-btn class="ml-3 custom_btn_secondary" @click="deleteDialog = false">CANCEL</v-btn> -->
                    </div>
                  </v-card-item>
                </v-card>
              </div>
            </v-card>
          </v-dialog>

          <v-data-table
            v-model:page="page"
            :loading="loading"
            :headers="headers"
            :items="timeManagementData"
            :items-per-page="itemsPerPage"
            class="custom_table_normal"
            @update:page="page = $event"
            @page-count="totalPages = $event"
          >
            <!-- Custom Styling for DAY column -->
            <template v-slot:[`item.day`]="{ item }">
              <span style="color: blue; font-weight: bold">{{ item.day }}</span>
            </template>

            <!-- Custom Styling for DAY IN column -->
            <template v-slot:[`item.day_in`]="{ item }">
              <span style="color: blue; font-weight: bold">{{
                formatTime(item.day_in)
              }}</span>
            </template>
            <template v-slot:[`item.day_in_buffer`]="{ item }">
              <span style="color: blue; font-weight: bold">{{
                formatTime(item.day_in_buffer)
              }}</span>
            </template>



            <template v-slot:[`item.created_at`]="{ item }">
              <span style="color: blue; font-weight: bold">
                {{
                  new Date(item.created_at)
                    .toISOString()
                    .slice(0, 10)
                    .replace(/-/g, "/")
                }}
              </span>
            </template>


            <!-- DELETE Button -->
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                style="
                  width: 70% !important;
                  background-color: #fdecea !important;
                  border: 1px solid #f44336 !important;
                  color: #f44336 !important;
                "
                variant="outlined"
                @click="confirmDelete(item)"
                :disabled="!permissions.delete"
              >
                DELETE
              </v-btn>
            </template>
          </v-data-table>
        </v-row>

        <v-dialog
          v-model="deleteDialog"
          max-height="500"
          max-width="500"
          persistent
          id="app_product_list"
        >
          <v-card rounded="md">
            <div class="pa-4">
              <v-card color="#F0F0F0" flat>
                <template v-slot:prepend>
                  <v-card-title class="text-subtitle-1 font-weight-bold"
                    >DELETE TIME MANAGEMENT DATA</v-card-title
                  >
                </template>
                <v-spacer></v-spacer>
                <template v-slot:append>
                  <v-btn
                    @click="deleteDialog = false"
                    icon="mdi-close"
                    size="x-small"
                  ></v-btn>
                </template>
              </v-card>

              <v-card color="white" flat class="mt-3">
                <v-card-item>
                  <v-card-title
                    style="color: #bb0000"
                    class="text-body-1 font-weight-medium"
                  >
                    <v-icon color="warning" size="small">mdi-alert</v-icon>
                    &nbsp;&nbsp;Do you want to delete this time record ?
                  </v-card-title>

                  <p style="opacity: 0.7" class="text-body-2 mt-4 text-justify">
                    This will be deleted immediately. Once deleted, it can no
                    longer be used for any purpose.
                    <span style="color: blue">
                      Further, these modules are also related to the following
                      others, so please read and confirm before deleting this.
                    </span>
                  </p>

                  <!-- <v-timeline align="start" density="compact">
                    <v-timeline-item>
                      <template v-slot:opposite> </template>
                      <div>
                        <div class="text-h6">related area 01</div>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </v-timeline-item>

                    <v-timeline-item>
                      <template v-slot:opposite> </template>
                      <div>
                        <div class="text-h6">related area 02</div>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </v-timeline-item>
                  </v-timeline> -->

                  <v-divider class="mt-4"></v-divider>

                  <div class="float-end mt-4">
                    <v-btn
                      style="
                        width: 35% !important;
                        background-color: #fdecea !important;
                        border: 1px solid #f44336 !important;
                        color: #f44336 !important;
                      "
                      variant="outlined"
                      @click="deleteTimeManagement"
                      :loading="deleteLoading"
                    >
                      DELETE
                    </v-btn>
                    <v-btn
                      class="ml-3 custom_btn_secondary"
                      @click="deleteDialog = false"
                      >CANCEL</v-btn
                    >
                  </div>
                </v-card-item>
              </v-card>
            </div>
          </v-card>
        </v-dialog>

        <!-- Snackbar for notifications -->
        <v-snackbar
          v-model="snackbar"
          :timeout="3000"
          :color="snackbarColor"
          top
        >
          {{ snackbarMessage }}
        </v-snackbar>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import { getPermissions } from "@/plugins/permissions";

export default {
  data() {
    return {
      createDialog: false,
      days: [
        { name: "Monday", value: "Monday" },
        { name: "Tuesday", value: "Tuesday" },
        { name: "Wednesday", value: "Wednesday" },
        { name: "Thursday", value: "Thursday" },
        { name: "Friday", value: "Friday" },
        { name: "Saturday", value: "Saturday" },
        { name: "Sunday", value: "Sunday" },
      ],
      permissions: {},
      selectedDay: null,
      dayInTime: null,
      dayInMenu: false,
      dayInBufferTime: null,
      dayInBufferMenu: false,
      morningHDTime: null,
      morningHDMenu: false,
      afternoonHDTime: null,
      afternoonHDMenu: false,
      fullDayLeaveTime: null,
      fullDayLeaveMenu: false,
      dayOutTime: null,
      dayOutMenu: false,
      deleteDialog: false,
      deleteLoading: false,
      itemToDelete: null,
      userPermissions: ["delete"],
      centerLoading: false,
      page: 1,
      loading: false,
      itemsPerPage: 10,
      timeManagementData: [],
      headers: [
        { text: "DAY", value: "day", title:"DAY" },
        { text: "DAY IN", value: "day_in",title:"DAY IN" },
        { text: "DAY IN BUFFER", value: "day_in_buffer",title:"DAY IN BUFFER" },
        { text: "MORNING HD LEAVE", value: "morning_hd_leave",title:"MORNING HD LEAVE" },
        { text: "AFTERNOON HD LEAVE", value: "afternoon_hd_leave",title:"AFTERNOON HD LEAVE" },
        { text: "FULL DAY LEAVE", value: "full_day_leave",title:"FULL DAY LEAVE" },
        { text: "DAY OUT", value: "day_out" ,title:"DAY OUT"},
        { text: "CREATED AT", value: "created_at" ,title:"CREATED AT"},
        { text: "ACTION", value: "actions", sortable: false ,title:"ACTION"},
      ],
      snackbar: false,
      snackbarMessage: "",
      snackbarColor: "success",
    };
  },
  mounted() {

    const dashboardId = 10;
    this.permissions = getPermissions(dashboardId);
  },
  created() {
    this.fetchTimeManagementData();
  },
  methods: {
    formatTime(timeString) {
      if (!timeString) return "";
      const [hours, minutes] = timeString.split(":");
      const hour = parseInt(hours);
      const ampm = hour >= 12 ? "PM" : "AM";
      const hour12 = hour % 12 || 12;
      return `${hour12}:${minutes} ${ampm}`;
    },
    isAfter(startTime, endTime) {
      if (!startTime || !endTime) return true;
      const [startH, startM] = startTime.split(":").map(Number);
      const [endH, endM] = endTime.split(":").map(Number);
      if (endH > startH) return true;
      if (endH === startH && endM > startM) return true;
      return false;
    },
    verifyDialogOpen() {
      const { selectedDay, dayInTime, dayInBufferTime, morningHDTime, afternoonHDTime, fullDayLeaveTime, dayOutTime } = this;
      const errors = [];
      if (!selectedDay) errors.push("Day is required.");
      if (!dayInTime) errors.push("Day In time is required.");
      if (!dayInBufferTime) errors.push("Day In Buffer time is required.");
      if (!morningHDTime) errors.push("Morning HD Leave is required.");
      if (!afternoonHDTime) errors.push("Afternoon HD Leave is required.");
      if (!fullDayLeaveTime) errors.push("Full Day Leave is required.");
      if (!dayOutTime) errors.push("Day Out time is required.");

    if(morningHDTime,afternoonHDTime,dayInTime,dayInBufferTime,fullDayLeaveTime>dayOutTime)
       {errors.push("Day Out Time must be greater than all previous times.");}


    if (
    dayOutTime <= morningHDTime ||
    dayOutTime <= afternoonHDTime ||
    dayOutTime <= dayInTime ||
    dayOutTime <= dayInBufferTime ||
    dayOutTime <= fullDayLeaveTime
    ) {
        errors.push("Day Out Time must be greater than all previous times.");
    }   

  

      if (errors.length === 0) {
        if (!this.isAfter(dayInTime, dayInBufferTime)) errors.push("Day In Buffer must be after Day In.");
        if (!this.isAfter(dayInTime, morningHDTime)) errors.push("Morning Half-Day Leave must be after Day In.");
        if (!this.isAfter(morningHDTime, afternoonHDTime)) errors.push("Afternoon Half-Day Leave must be after Morning Half-Day Leave.");
        if (!this.isAfter(dayInTime, fullDayLeaveTime)) errors.push("Full Day Leave must be after Day In.");
        if (!this.isAfter(dayInTime, dayOutTime)) errors.push("Day Out must be after Day In.");
      }

      if (errors.length > 0) {
        this.showSnackbar(errors.join(' '), "error");
        return;
      }
      this.createDialog = true;
    },
    async fetchTimeManagementData() {
      this.loading = true;
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}api/am/web/time-management/get`, {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response.data.success) this.timeManagementData = response.data.data;
        else this.showSnackbar("Failed to fetch data", "error");
      } catch (e) {
        this.showSnackbar("API Error", "error");
      } finally { this.loading = false; }
    },
    async CreateTime() {
      if (!this.selectedDay) return this.showSnackbar("Please select a day", "error");
      this.loading = true;
      const userId = localStorage.getItem("userId");
      const timeData = {
        user_id: userId, day: this.selectedDay, day_in: this.dayInTime, day_in_buffer: this.dayInBufferTime,
        morning_hd_leave: this.morningHDTime, afternoon_hd_leave: this.afternoonHDTime,
        full_day_leave: this.fullDayLeaveTime, day_out: this.dayOutTime, status: "current",
      };
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(`${process.env.VUE_APP_API_BASE_URL}api/am/web/time-management/create`, timeData,
          { headers: { Authorization: `Bearer ${token}` } });
        if (response.data.success) {
          this.showSnackbar("Created successfully", "success");
          this.createDialog = false; this.resetForm(); this.fetchTimeManagementData();
        } else this.showSnackbar("Failed to create", "error");
      } catch (e) { this.showSnackbar("API Error", "error"); }
      finally { this.loading = false; }
    },
    confirmDelete(item) { this.itemToDelete = item; this.deleteDialog = true; },
    async deleteTimeManagement() {
      if (!this.itemToDelete) return;
      this.deleteLoading = true;
      try {
        const token = localStorage.getItem("token");
        await axios.post(`${process.env.VUE_APP_API_BASE_URL}api/am/web/time-management/delete`,
          { user_id: localStorage.getItem("userId"), id: this.itemToDelete.id },
          { headers: { Authorization: `Bearer ${token}` } });
        this.showSnackbar("Deleted successfully", "success");
        this.fetchTimeManagementData();
      } catch (e) { this.showSnackbar("Delete error", "error"); }
      finally { this.deleteLoading = false; this.deleteDialog = false; this.itemToDelete = null; }
    },
    resetForm() {
      this.selectedDay = this.dayInTime = this.dayInBufferTime = this.morningHDTime = this.afternoonHDTime = this.fullDayLeaveTime = this.dayOutTime = null;
    },
    showSnackbar(message, color) { this.snackbarMessage = message; this.snackbarColor = color; this.snackbar = true; },
    hasPermission(permission) { return this.userPermissions.includes(permission); },
    cancel() { this.resetForm(); },
    backPageRoute() { this.$router.go(-1); },
  }
}
</script>

<style scoped></style>